import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { getKey, isUrlAbsolute } from '../../utils/common';
import NotFound from './notFound';
import CONSTANT from '../../utils/constants';

class BankLists extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.alpahbetStringData = this.filterBankListByAlphabates(props.bankListsData);
  }

  filterBankListByAlphabates = bankListsData => {
    const bankAlphabates = [];
    const bankAlphabatesMap = {};
    bankListsData.forEach(bankData => {
      if (bankData.channelName) {
        const firstChar = bankData.channelName.toUpperCase().charAt(0);
        if (!Object.prototype.hasOwnProperty.call(bankAlphabatesMap, firstChar)) {
          bankAlphabatesMap[firstChar] = 1;
          bankAlphabates.push(firstChar);
        }
      }
    });
    return bankAlphabates.sort();
  };

  render({ bankListsData, BankOptionClick, filterBankData, showFilteredData, alphabetFilter }, {}) {
    let banks = bankListsData;
    if (filterBankData.length || showFilteredData) {
      banks = filterBankData;
    }
    const isfilteredData = !!banks.length;
    const iconBaseUrl = this.props.cache.getData(CONSTANT.ICON_BASE_URL);
    return (
      <div className={`ptm-nb-list-wrapper ptm-pos-r`}>
        <div className={`ptm-nb-bankcard-wrapper ptm-pos-r`} id="checkout-nb-banks-list">
          {!isfilteredData && <NotFound />}
          {isfilteredData &&
            banks.map(bankData => (
              <div
                className={`ptm-nb-bankcard ptm-pos-r nb-border`}
                onClick={() => BankOptionClick(bankData)}
              >
                <div className={`ptm-nb-cardimg ptm-pos-a ptm-global-border`}>
                  <img
                    className={`ptm-centralized ptm-pos-a ptm-margin0`}
                    src={
                      isUrlAbsolute(bankData.iconUrl)
                        ? bankData.iconUrl
                        : iconBaseUrl + bankData.iconUrl
                    }
                    alt=""
                  />
                </div>
                <span className={`ptm-body-color`}>{bankData.channelName}</span>
                {bankData.hasLowSuccess &&
                  getKey(bankData.hasLowSuccess, 'status') &&
                  getKey(bankData.hasLowSuccess, 'msg') && (
                    <p className={`ptm-low-success`}>{bankData.hasLowSuccess.msg}</p>
                  )}
              </div>
            ))}
        </div>
        {isfilteredData && (
          <div className={`ptm-filter-wrap ptm-pos-a ptm-body-bg`}>
            {this.alpahbetStringData.map(value => (
              <span className={`ptm-body-color`} onClick={() => alphabetFilter(value)}>
                {value}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  'cache',
  null
)(BankLists);



// WEBPACK FOOTER //
// ./components/nb/BankLists.js